import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

import { Table } from '../../../../components/table/table';
import { HeadCell, Row, RowCell } from '../../../../components/table/types';

import { UTCToDateTime } from '../../../../utils/dates';
import { GetRateMarkupResult } from '../../../../api';

type HistoryModalProps = {
  open: boolean;
  onClose: () => void;
  rateMarkup: GetRateMarkupResult | undefined;
  isRateMarkupLoading: boolean;
};

export const HistoryModal: FC<HistoryModalProps> = (props) => {
  const { open, onClose, rateMarkup, isRateMarkupLoading } = props;
  const { t } = useTranslation();

  const headCells: HeadCell[] = [
    {
      id: '1',
      label: t('exchange-fees.history-modal.head-cells.valid-from'),
    },
    {
      id: '2',
      label: t('exchange-fees.history-modal.head-cells.valid-to'),
    },
    {
      id: '3',
      label: t('exchange-fees.history-modal.head-cells.percent'),
      align: 'right',
    },
  ];

  const rows: Row[] | undefined = rateMarkup?.archived?.map((it) => {
    const { row_start, validity, percent } = it;

    const cells: RowCell[] = [
      {
        name: 'row_start',
        value: row_start,
        formatting: (value: string) => {
          return value ? UTCToDateTime(value) : '–';
        },
      },
      {
        name: 'validity',
        value: validity,
        formatting: (value: string) => {
          return UTCToDateTime(value);
        },
      },
      {
        name: 'percent',
        value: percent,
        align: 'right',
        formatting: (value: string) => {
          return `${value} %`;
        },
      },
    ];

    return { cells };
  });

  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ sx: { minWidth: '380px' } }}>
      <DialogTitle>
        {/*{t('exchange-fees.history-modal.title')}*/}
        {!isRateMarkupLoading &&
          `${rateMarkup?.rateMarkup?.from_coin?.name} -> ${rateMarkup?.rateMarkup?.to_coin?.name}`}
      </DialogTitle>
      <IconButton
        aria-label="close"
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent>
        {isRateMarkupLoading ? (
          <Box style={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress />
          </Box>
        ) : (
          <Table headCells={headCells} rows={rows} />
        )}
      </DialogContent>
    </Dialog>
  );
};
